document.addEventListener("DOMContentLoaded", function () {
  initCompareTables();
});

function initCompareTables() {
  const compareTables = document.querySelectorAll("[data-compare-table]");

  compareTables.forEach((table) => {
    if (table.dataset.compareTableReady === "true") return;
    table.dataset.compareTableReady = "true";

    const dropdown = table.querySelector("[data-compare-table-dropdown]");
    const trigger = table.querySelector("[data-compare-table-trigger]");
    const list = table.querySelector("[data-compare-table-list]");
    const label = table.querySelector("[data-compare-table-label]");
    const options = table.querySelectorAll("[data-compare-table-option]");
    const otherColumns = table.querySelectorAll(
      ".compare-table__column--other",
    );

    const setSelectedColumn = (columnId) => {
      otherColumns.forEach((column) => {
        column.classList.toggle(
          "compare-table__column--selected",
          column.dataset.columnId === columnId,
        );
      });
    };

    const closeDropdown = () => {
      if (!dropdown || !trigger || !list) return;
      dropdown.classList.remove("is-open");
      trigger.setAttribute("aria-expanded", "false");
      list.hidden = true;
    };

    const openDropdown = () => {
      if (!dropdown || !trigger || !list) return;
      dropdown.classList.add("is-open");
      trigger.setAttribute("aria-expanded", "true");
      list.hidden = false;
    };

    const toggleDropdown = () => {
      if (!dropdown) return;
      if (dropdown.classList.contains("is-open")) {
        closeDropdown();
      } else {
        openDropdown();
      }
    };

    if (dropdown && trigger && list && options.length) {
      trigger.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        toggleDropdown();
      });

      options.forEach((option) => {
        option.addEventListener("click", (event) => {
          event.preventDefault();
          event.stopPropagation();

          const value = option.dataset.value;
          const optionLabel = option.dataset.label;

          options.forEach((item) => {
            const isSelected = item === option;
            item.classList.toggle("is-selected", isSelected);
            item.setAttribute("aria-selected", isSelected ? "true" : "false");
          });

          if (label && optionLabel) {
            label.textContent = optionLabel;
          }

          setSelectedColumn(value);
          equalizeCompareTableRows(table);
          closeDropdown();
        });
      });

      document.addEventListener("click", (event) => {
        if (!dropdown.contains(event.target)) {
          closeDropdown();
        }
      });

      document.addEventListener("keydown", (event) => {
        if (event.key === "Escape") {
          closeDropdown();
        }
      });

      const initiallySelected =
        table.querySelector("[data-compare-table-option].is-selected") ||
        options[0];

      if (initiallySelected) {
        setSelectedColumn(initiallySelected.dataset.value);
      }
    }

    equalizeCompareTableRows(table);
    initCompareTableVariantSync(table);
    initCompareTableBannerAnimation(table);
  });

  if (!window.__compareTableResizeBound) {
    window.__compareTableResizeBound = true;
    let compareTableResizeTimer;
    window.addEventListener("resize", () => {
      clearTimeout(compareTableResizeTimer);
      compareTableResizeTimer = setTimeout(() => {
        document.querySelectorAll("[data-compare-table]").forEach((table) => {
          equalizeCompareTableRows(table);
        });
      }, 150);
    });
  }
}

function initCompareTableBannerAnimation(table) {
  const bannerImage = table.querySelector(
    ".compare-table__column--highlighted .compare-table__banner-image-element",
  );
  if (!bannerImage || typeof IntersectionObserver === "undefined") return;

  const prefersReducedMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)",
  ).matches;
  if (prefersReducedMotion) return;

  const isMobile = () => window.matchMedia("(max-width: 1023px)").matches;

  const playBounce = () => {
    if (!isMobile()) return;
    bannerImage.classList.remove("is-banner-animated");
    // Force reflow so the animation can replay if needed
    void bannerImage.offsetWidth;
    bannerImage.classList.add("is-banner-animated");
  };

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        playBounce();
        observer.unobserve(entry.target);
      });
    },
    {
      threshold: 0.35,
      rootMargin: "0px 0px -8% 0px",
    },
  );

  observer.observe(table);
}

function initCompareTableVariantSync(table) {
  if (!table.hasAttribute("data-compare-table-pdp")) return;

  const highlighted = table.querySelector("[data-compare-highlighted]");
  if (!highlighted) return;

  let variants = [];
  try {
    variants = JSON.parse(highlighted.dataset.variants || "[]");
  } catch (error) {
    variants = [];
  }

  if (!variants.length) return;

  const bannerImage = highlighted.querySelector(
    ".compare-table__banner-image-element",
  );
  const defaultBg = highlighted.dataset.defaultBg || "";
  const defaultBanner = highlighted.dataset.defaultBanner || "";

  const applyVariantStyle = (variantId) => {
    const match = variants.find((variant) => {
      const ids = Array.isArray(variant.ids) ? variant.ids : [];
      return ids.some((id) => String(id) === String(variantId));
    });
    const background = (match && match.background) || defaultBg;
    const banner = (match && match.banner) || defaultBanner;

    if (background) {
      highlighted.style.setProperty("--compare-column-bg", background);
    } else {
      highlighted.style.removeProperty("--compare-column-bg");
    }

    if (bannerImage && banner) {
      bannerImage.src = banner;
      bannerImage.removeAttribute("srcset");
      bannerImage.removeAttribute("sizes");
    }
  };

  const getCurrentVariantId = () => {
    const params = new URLSearchParams(window.location.search);
    const urlVariant = params.get("variant");
    if (urlVariant) return urlVariant;

    const variantInput = document.querySelector(
      'product-info [name="id"], form[action*="/cart/add"] [name="id"]',
    );
    return variantInput ? variantInput.value : null;
  };

  const initialVariantId = getCurrentVariantId();
  if (initialVariantId) {
    applyVariantStyle(initialVariantId);
  }

  if (
    typeof subscribe === "function" &&
    typeof PUB_SUB_EVENTS !== "undefined"
  ) {
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const variantId =
        event && event.data && event.data.variant && event.data.variant.id;
      if (variantId == null) {
        applyVariantStyle(null);
        return;
      }
      applyVariantStyle(variantId);
    });
  }
}

function equalizeCompareTableRows(table) {
  const isDesktop = window.matchMedia("(min-width: 1024px)").matches;
  const visibleColumns = Array.from(
    table.querySelectorAll(".compare-table__column"),
  ).filter((column) => {
    if (column.classList.contains("compare-table__column--other")) {
      return (
        column.classList.contains("compare-table__column--selected") ||
        isDesktop
      );
    }
    return true;
  });

  if (!visibleColumns.length) return;

  const rowMap = new Map();

  visibleColumns.forEach((column) => {
    column.querySelectorAll(".compare-table__cell").forEach((cell) => {
      const index = cell.dataset.rowIndex;
      if (!rowMap.has(index)) rowMap.set(index, []);
      rowMap.get(index).push(cell);
    });
  });

  // rowMap.forEach((cells) => {
  //   cells.forEach((cell) => {
  //     cell.style.minHeight = '';
  //   });

  //   let maxHeight = 0;
  //   cells.forEach((cell) => {
  //     maxHeight = Math.max(maxHeight, cell.offsetHeight);
  //   });

  //   cells.forEach((cell) => {
  //     cell.style.minHeight = `${maxHeight}px`;
  //   });
  // });
}
